<template>
    <div v-html="toHTML" />
</template>

<script>

import { marked } from 'marked'

export default {
    props: {
        content: {
            type: String,
            required: true,
        },
    },

    computed: {
        /**
         * Convert the props content from Markdown to HTML.
         * @returns {string}
         */
        toHTML() {
            return marked(this.content || '', { smartypants: true })
        },
    },
}

</script>
